<template>
    <v-navigation-drawer
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="drawer"
        temporary
        floating
        fixed
    >

        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="title">
                    방문 예약
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-4"></v-divider>

        <v-list
            dense
            nav
        >
            <v-list-item
                v-for="item in availableMenuItems"
                v-show="!item.requiredAuth || (item.requiredAuth && currentUser)"
                :key="item.title"
                link
            >
                <v-list-item-content>
                    <v-list-item-title @click="goto(item)">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

    </v-navigation-drawer>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'HomeDrawer',

    data: () => ({}),

    computed: {
        ...mapState(['menuItemList', 'currentUser']),

        availableMenuItems() {
            return this.menuItemList
                .filter(item => {
                    return item.isShow;
                })
                .filter(item => !item.requiredAuth || (item.requiredAuth && this.currentUser));
        },

        drawer: {
            get() {
                return this.$store.state.drawer
            },
            set(val) {
                this.$store.commit('SET_DRAWER', val)
            }
        },
    },

    methods: {
        goto(menuItem) {
            if (menuItem.href) {
                window.location.href = menuItem.href;
            } else if (this.$route.name !== menuItem.name) {
                this.$router.push({name: menuItem.name});
            }
        }
    }
}
</script>